import { isNaN, isNil } from 'lodash'

export default function getTokenName(tokenId:number, collectionName: string, name: string) {
	const isGeneric = name && name.startsWith('#')

	if (isGeneric) {
		return `${collectionName} ${name}`
	}

	const isString = name && isNaN(name)

	if (isString) {
		return `${name}`
	}

	if (isNil(collectionName) || isNil(tokenId)) {
		return 'PFP Name Unknown'
	}

	return `${collectionName} #${tokenId}`
}
